import React, { useState, ReactElement } from 'react';
import { CarImage, ClaimsText, DealerText, ShowVideoNudge, SlideContent, SlidesImageWrapper, TextContainer, WatchVideoText } from './styles';
import GenericCarousel from '@components/GenericCarousel';
import { CommonProps } from '@utils/interface';
import { resolvePath } from '@utils/resolvePath';
import { Flex } from '@acko-tech/building-blocks.ui.common';
import ImageContainer from '@components/imageContainer';

interface CarClaimsSlideProps {
    claimsText: string;
    dealerText: string;
    month: string;
    imageSrc: string;
    gradient?: string;
    $activeIndex?: number
    id?: number
    actionText?: string
}

const CarClaimsSlide: React.FC<CarClaimsSlideProps> = ({ claimsText, dealerText, month, imageSrc, gradient, $activeIndex, id, actionText }) => (
    <>
        <SlideContent style={{ background: gradient }}>
            <SlidesImageWrapper>
                <ImageContainer
                    imgSrc={resolvePath(imageSrc)}
                    alt="Car with a gift ribbon"
                    height="56px"
                    width="56px"
                />
            </SlidesImageWrapper>
            <TextContainer>
                <ClaimsText>
                    {claimsText}
                </ClaimsText>
                <DealerText>
                    {dealerText}
                </DealerText>
            </TextContainer>
        </SlideContent>
        <Flex justifyContent='center' width='108%' margin='0 auto' alignItems='center'>
            {id === $activeIndex ? <ShowVideoNudge>
                <div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                        <path d="M13.25 6.56699C13.5833 6.75944 13.5833 7.24056 13.25 7.43301L4.25 12.6292C3.91667 12.8216 3.5 12.5811 3.5 12.1962V1.80385C3.5 1.41895 3.91667 1.17838 4.25 1.37083L13.25 6.56699Z" fill="#5920C5" />
                    </svg>
                </div>
                <div>
                    <WatchVideoText>{actionText}</WatchVideoText>
                </div>
            </ShowVideoNudge> : null}
        </Flex>
    </>
);
interface ClaimsCarousalProps extends CommonProps {
    slides: CarClaimsSlideProps[]
}
const ClaimsCarousel: React.FC<ClaimsCarousalProps> = (props) => {
    const { is_visible, slides } = props
    const slideComponents: ReactElement[] = slides?.map((data, index) => (
        <CarClaimsSlide
            key={index}
            {...data}
        />
    ));

    return (
        is_visible ? <div style={{ fontFamily: 'sans-serif', maxWidth: "100%" }}>
            <GenericCarousel totalSlides={slideComponents} />
        </div> : null
    );
};

export default ClaimsCarousel;